import React, { useState } from "react";

const Login = () => {
  const [password, setPassword] = useState("");
  const [show, setShow] = useState(false);

  // default password (first time)
  const savedPassword = localStorage.getItem("adminPass") || "Durgesh@5707061";

  const handleLogin = () => {
    if (password === savedPassword) {
      localStorage.setItem("auth", "true");
      window.location.href = "/admin";
    } else {
      alert("Wrong Password ❌");
    }
  };

  return (
    <div style={{
      height: "100vh",
      display: "flex",
      justifyContent: "center",
      alignItems: "center",
      background: "#f1f5f9"
    }}>
      <div style={{
        background: "white",
        padding: 30,
        borderRadius: 12,
        width: 300,
        textAlign: "center",
        boxShadow: "0 4px 20px rgba(0,0,0,0.1)"
      }}>
        <h2>🔐 Admin Login</h2>

        {/* PASSWORD INPUT */}
        <div style={{ position: "relative" }}>
          <input
            type={show ? "text" : "password"}
            placeholder="Enter password"
            value={password}
            onChange={(e) => setPassword(e.target.value)}
            style={{
              padding: "10px",
              width: "100%",
              marginTop: "10px",
              borderRadius: "6px",
              border: "1px solid #ccc"
            }}
          />

          {/* 👁 SHOW BUTTON */}
          <span
            onClick={() => setShow(!show)}
            style={{
              position: "absolute",
              right: 10,
              top: 18,
              cursor: "pointer",
              fontSize: 14
            }}
          >
            {show ? "🙈" : "👁"}
          </span>
        </div>

        <button
          onClick={handleLogin}
          style={{
            marginTop: 15,
            padding: "10px",
            width: "100%",
            background: "#2563eb",
            color: "white",
            border: "none",
            borderRadius: 6,
            cursor: "pointer"
          }}
        >
          Login
        </button>
      </div>
    </div>
  );
};

export default Login;